import {
  TEAM_MEMBERS_CHANGE,
  TEAM_MEMBERS_EDIT_CHANGE,
  TEAM_MEMBERS_ADD,
  TEAM_MEMBERS_DELETE,
  TEAM_MEMBERS_GET,
  TEAM_MEMBERS_GET_ALL,
  TEAM_MEMBERS_RESET,
  SET_TEAM_MEMBERS_LOADING,
  SET_TEAM_MEMBERS_SUBMITTING,
  SET_TEAM_MEMBERS_FORM_ERRORS,
  SET_TEAM_MEMBERS_FORM_EDIT_ERRORS,
} from './constants';

const initialFormData = {
  name: '',
  role: '',
  image: '',
  bio: '',
};

const initialState = {
  teamMemberFormData: { ...initialFormData },
  teamMembersList: [],
  teamMembersCount: 0,
  teamMember: {
    _id: '',
  },
  formErrors: {},
  editFormErrors: {},
  isLoading: false,
  isSubmitting: false,
};

const teamMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEAM_MEMBERS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_TEAM_MEMBERS_SUBMITTING:
      return {
        ...state,
        isSubmitting: action.payload,
      };
    case SET_TEAM_MEMBERS_FORM_ERRORS:
      return {
        ...state,
        formErrors: action.payload,
      };
    case SET_TEAM_MEMBERS_FORM_EDIT_ERRORS:
      return {
        ...state,
        editFormErrors: action.payload,
      };
    case TEAM_MEMBERS_CHANGE:
      return {
        ...state,
        teamMemberFormData: {
          ...state.teamMemberFormData,
          ...action.payload,
        },
      };
    case TEAM_MEMBERS_EDIT_CHANGE:
      return {
        ...state,
        teamMember: {
          ...state.teamMember,
          ...action.payload,
        },
      };
    case TEAM_MEMBERS_ADD:
      return {
        ...state,
        teamMembersList: [...state.teamMembersList, action.payload],
        teamMembersCount: state.teamMembersCount + 1,
      };
    case TEAM_MEMBERS_DELETE:
      return {
        ...state,
        teamMembersList: state.teamMembersList.filter(
          (teamMember) => teamMember._id !== action.payload
        ),
        teamMembersCount: Math.max(0, state.teamMembersCount - 1),
      };
    case TEAM_MEMBERS_GET:
      return {
        ...state,
        teamMember: { ...action.payload },
        editFormErrors: {},
      };
    case TEAM_MEMBERS_GET_ALL:
      return {
        ...state,
        teamMembersList: action.payload || [],
        teamMembersCount: (action.payload || []).length,
      };
    case TEAM_MEMBERS_RESET:
      return {
        ...state,
        teamMemberFormData: { ...initialFormData },
        teamMember: { _id: '' },
        formErrors: {},
        editFormErrors: {},
        isSubmitting: false,
      };
    default:
      return state;
  }
};

export default teamMembersReducer;
